/**
 * Seed catalog for Firestore `workTypes` — from Pipedrive products.
 * Used only to populate the collection; runtime reads come from Firestore.
 * All Pipedrive-sourced work types sit under Delivery Team for now.
 */
export interface WorkTypeSeed {
  id: string
  name: string
  team: string
  pipedriveCategory: string | null
  sourceProductIds: number[]
}

export const WORK_TYPES_SEED: WorkTypeSeed[] = [
  {
    "id": "wt-568",
    "name": "ACT Building Act 2004 Design Certificate",
    "team": "Delivery Team",
    "pipedriveCategory": null,
    "sourceProductIds": [
      568
    ]
  },
  {
    "id": "wt-532",
    "name": "Address, Date or BCN Number Change",
    "team": "Delivery Team",
    "pipedriveCategory": "Admin",
    "sourceProductIds": [
      532
    ]
  },
  {
    "id": "wt-618",
    "name": "Allowance for Construction Monitoring (remote and onsite)",
    "team": "Delivery Team",
    "pipedriveCategory": "General",
    "sourceProductIds": [
      618
    ]
  },
  {
    "id": "wt-737",
    "name": "Allowance for Construction Monitoring, onsite inspections",
    "team": "Delivery Team",
    "pipedriveCategory": null,
    "sourceProductIds": [
      737
    ]
  },
  {
    "id": "wt-738",
    "name": "Allowance for Construction Monitoring, remote (video based) inspections",
    "team": "Delivery Team",
    "pipedriveCategory": null,
    "sourceProductIds": [
      738
    ]
  },
  {
    "id": "wt-615",
    "name": "Allowance for Construction Phase Support - CANs & RFIs",
    "team": "Delivery Team",
    "pipedriveCategory": "Interiors - Large Projects",
    "sourceProductIds": [
      615
    ]
  },
  {
    "id": "wt-616",
    "name": "Allowance for Design Meetings",
    "team": "Delivery Team",
    "pipedriveCategory": "Interiors - Large Projects",
    "sourceProductIds": [
      616
    ]
  },
  {
    "id": "wt-752",
    "name": "Allowance for Design Phase Support",
    "team": "Delivery Team",
    "pipedriveCategory": null,
    "sourceProductIds": [
      752
    ]
  },
  {
    "id": "wt-703",
    "name": "Allowance for Design Phase Support - Design Meetings & Coordination",
    "team": "Delivery Team",
    "pipedriveCategory": null,
    "sourceProductIds": [
      703
    ]
  },
  {
    "id": "wt-544",
    "name": "Assessment and Analysis",
    "team": "Delivery Team",
    "pipedriveCategory": "General",
    "sourceProductIds": [
      544
    ]
  },
  {
    "id": "wt-685",
    "name": "Assessment and Analysis - Events",
    "team": "Delivery Team",
    "pipedriveCategory": "Events",
    "sourceProductIds": [
      685
    ]
  },
  {
    "id": "wt-577",
    "name": "B2 Durability Compliance Letter",
    "team": "Delivery Team",
    "pipedriveCategory": "Documentation",
    "sourceProductIds": [
      577
    ]
  },
  {
    "id": "wt-712",
    "name": "Bespoke - Design of Facade Support Framing",
    "team": "Delivery Team",
    "pipedriveCategory": null,
    "sourceProductIds": [
      712
    ]
  },
  {
    "id": "wt-513",
    "name": "Bespoke Design",
    "team": "Delivery Team",
    "pipedriveCategory": "Interiors",
    "sourceProductIds": [
      513
    ]
  },
  {
    "id": "wt-664",
    "name": "Bespoke Design - Fall Arrest System",
    "team": "Delivery Team",
    "pipedriveCategory": "Fall Arrest",
    "sourceProductIds": [
      664
    ]
  },
  {
    "id": "wt-711",
    "name": "Bespoke Design - Secondary Supports (Timber and Steel) for facade systems",
    "team": "Delivery Team",
    "pipedriveCategory": null,
    "sourceProductIds": [
      711
    ]
  },
  {
    "id": "wt-650",
    "name": "Bespoke Design - Structural Restraints for Complex Operable Wall",
    "team": "Delivery Team",
    "pipedriveCategory": "Interiors",
    "sourceProductIds": [
      650
    ]
  },
  {
    "id": "wt-648",
    "name": "Bespoke Design - Structural Restraints for Simple Operable Wall",
    "team": "Delivery Team",
    "pipedriveCategory": "Interiors",
    "sourceProductIds": [
      648
    ]
  },
  {
    "id": "wt-649",
    "name": "Bespoke Design - Structural Restraints for Standard Operable Wall",
    "team": "Delivery Team",
    "pipedriveCategory": "Interiors",
    "sourceProductIds": [
      649
    ]
  },
  {
    "id": "wt-780",
    "name": "Bespoke Lintel Design",
    "team": "Delivery Team",
    "pipedriveCategory": null,
    "sourceProductIds": [
      780
    ]
  },
  {
    "id": "wt-512",
    "name": "Bespoke seismic restraint design for partitions",
    "team": "Delivery Team",
    "pipedriveCategory": "Interiors",
    "sourceProductIds": [
      512
    ]
  },
  {
    "id": "wt-701",
    "name": "Bespoke Service - Equipment Review of Case Study",
    "team": "Delivery Team",
    "pipedriveCategory": null,
    "sourceProductIds": [
      701
    ]
  },
  {
    "id": "wt-697",
    "name": "Bespoke Service - Review of IL4 mechanical gravity supports in plantrooms",
    "team": "Delivery Team",
    "pipedriveCategory": null,
    "sourceProductIds": [
      697
    ]
  },
  {
    "id": "wt-662",
    "name": "BIM & 3D Model Deliverables",
    "team": "Delivery Team",
    "pipedriveCategory": "Interiors - Large Projects",
    "sourceProductIds": [
      662
    ]
  },
  {
    "id": "wt-543",
    "name": "BIM Modelling (LOD300)",
    "team": "Delivery Team",
    "pipedriveCategory": "Interiors - Large Projects",
    "sourceProductIds": [
      543
    ]
  },
  {
    "id": "wt-744",
    "name": "BIMSS - Preconstruction Preliminary Design",
    "team": "Delivery Team",
    "pipedriveCategory": null,
    "sourceProductIds": [
      744
    ]
  },
  {
    "id": "wt-745",
    "name": "BIMSS - Seismic Restraint Design of Combined Services, Prefabricated Modules, per SQM",
    "team": "Delivery Team",
    "pipedriveCategory": null,
    "sourceProductIds": [
      745
    ]
  },
  {
    "id": "wt-749",
    "name": "BIMSS - Seismic Restraint Design of Combined Services, Suspended , per SQM",
    "team": "Delivery Team",
    "pipedriveCategory": null,
    "sourceProductIds": [
      749
    ]
  },
  {
    "id": "wt-721",
    "name": "Boundaryline - Annual Renewal of Generic PS1s",
    "team": "Delivery Team",
    "pipedriveCategory": null,
    "sourceProductIds": [
      721
    ]
  },
  {
    "id": "wt-716",
    "name": "Boundaryline - Bespoke element, hourly rate",
    "team": "Delivery Team",
    "pipedriveCategory": null,
    "sourceProductIds": [
      716
    ]
  },
  {
    "id": "wt-727",
    "name": "Boundaryline - Engineering Support, hourly rate (CAN, RFI, workshops)",
    "team": "Delivery Team",
    "pipedriveCategory": null,
    "sourceProductIds": [
      727
    ]
  },
  {
    "id": "wt-719",
    "name": "Boundaryline - Generic PS1, new",
    "team": "Delivery Team",
    "pipedriveCategory": null,
    "sourceProductIds": [
      719
    ]
  },
  {
    "id": "wt-720",
    "name": "Boundaryline - Generic PS1, revision of existing",
    "team": "Delivery Team",
    "pipedriveCategory": null,
    "sourceProductIds": [
      720
    ]
  },
  {
    "id": "wt-723",
    "name": "Boundaryline - Product development - Component",
    "team": "Delivery Team",
    "pipedriveCategory": null,
    "sourceProductIds": [
      723
    ]
  },
  {
    "id": "wt-722",
    "name": "Boundaryline - Product development - Full system",
    "team": "Delivery Team",
    "pipedriveCategory": null,
    "sourceProductIds": [
      722
    ]
  },
  {
    "id": "wt-717",
    "name": "Boundaryline - Site-specific PS1",
    "team": "Delivery Team",
    "pipedriveCategory": null,
    "sourceProductIds": [
      717
    ]
  },
  {
    "id": "wt-726",
    "name": "Boundaryline - Site-specific PS1 Revision",
    "team": "Delivery Team",
    "pipedriveCategory": null,
    "sourceProductIds": [
      726
    ]
  },
  {
    "id": "wt-724",
    "name": "Boundaryline - Site-specific PS4",
    "team": "Delivery Team",
    "pipedriveCategory": null,
    "sourceProductIds": [
      724
    ]
  },
  {
    "id": "wt-725",
    "name": "Boundaryline - Site-specific PS4 Revision",
    "team": "Delivery Team",
    "pipedriveCategory": null,
    "sourceProductIds": [
      725
    ]
  },
  {
    "id": "wt-754",
    "name": "Building Product Information Requirements (BPIR) Deliverable",
    "team": "Delivery Team",
    "pipedriveCategory": null,
    "sourceProductIds": [
      754
    ]
  },
  {
    "id": "wt-567",
    "name": "CAN Report - Complex",
    "team": "Delivery Team",
    "pipedriveCategory": "Documentation",
    "sourceProductIds": [
      567
    ]
  },
  {
    "id": "wt-646",
    "name": "CAN Report - Large",
    "team": "Delivery Team",
    "pipedriveCategory": "Documentation",
    "sourceProductIds": [
      646
    ]
  },
  {
    "id": "wt-528",
    "name": "CAN Report - Simple",
    "team": "Delivery Team",
    "pipedriveCategory": "Documentation",
    "sourceProductIds": [
      528
    ]
  },
  {
    "id": "wt-566",
    "name": "CAN Report - Standard",
    "team": "Delivery Team",
    "pipedriveCategory": "Documentation",
    "sourceProductIds": [
      566
    ]
  },
  {
    "id": "wt-550",
    "name": "Certificate Tag/ Label Reprint",
    "team": "Delivery Team",
    "pipedriveCategory": "Documentation",
    "sourceProductIds": [
      550
    ]
  },
  {
    "id": "wt-642",
    "name": "Clarifications",
    "team": "Delivery Team",
    "pipedriveCategory": null,
    "sourceProductIds": [
      642
    ]
  },
  {
    "id": "wt-683",
    "name": "Compliance Letter (For CPU)",
    "team": "Delivery Team",
    "pipedriveCategory": "Documentation",
    "sourceProductIds": [
      683
    ]
  },
  {
    "id": "wt-706",
    "name": "Conditions Inspection Report",
    "team": "Delivery Team",
    "pipedriveCategory": null,
    "sourceProductIds": [
      706
    ]
  },
  {
    "id": "wt-621",
    "name": "Construction Monitoring Onsite Inspection, Australia",
    "team": "Delivery Team",
    "pipedriveCategory": "General",
    "sourceProductIds": [
      621
    ]
  },
  {
    "id": "wt-514",
    "name": "Construction Monitoring Onsite Inspection, Metro",
    "team": "Delivery Team",
    "pipedriveCategory": "General",
    "sourceProductIds": [
      514
    ]
  },
  {
    "id": "wt-515",
    "name": "Construction Monitoring Onsite Inspection, Regional",
    "team": "Delivery Team",
    "pipedriveCategory": "General",
    "sourceProductIds": [
      515
    ]
  },
  {
    "id": "wt-628",
    "name": "Construction Monitoring, Photo-based Inspection",
    "team": "Delivery Team",
    "pipedriveCategory": "General",
    "sourceProductIds": [
      628
    ]
  },
  {
    "id": "wt-516",
    "name": "Construction Monitoring, Remote Inspection",
    "team": "Delivery Team",
    "pipedriveCategory": "General",
    "sourceProductIds": [
      516
    ]
  },
  {
    "id": "wt-647",
    "name": "Consultant Advisory Notice (CAN)",
    "team": "Delivery Team",
    "pipedriveCategory": "Documentation",
    "sourceProductIds": [
      647
    ]
  },
  {
    "id": "wt-679",
    "name": "Consulting",
    "team": "Delivery Team",
    "pipedriveCategory": null,
    "sourceProductIds": [
      679
    ]
  },
  {
    "id": "wt-609",
    "name": "Council Consent RFIs and PS2 Queries",
    "team": "Delivery Team",
    "pipedriveCategory": "Documentation",
    "sourceProductIds": [
      609
    ]
  },
  {
    "id": "wt-757",
    "name": "Council Form",
    "team": "Delivery Team",
    "pipedriveCategory": null,
    "sourceProductIds": [
      757
    ]
  },
  {
    "id": "wt-588",
    "name": "CPEng Product Certification to AS/NZ 1170.0, app. B",
    "team": "Delivery Team",
    "pipedriveCategory": "Design Compliance",
    "sourceProductIds": [
      588
    ]
  },
  {
    "id": "wt-545",
    "name": "Design Compliance Declaration",
    "team": "Delivery Team",
    "pipedriveCategory": null,
    "sourceProductIds": [
      545
    ]
  },
  {
    "id": "wt-694",
    "name": "Design Consultation / Workshop, Onsite",
    "team": "Delivery Team",
    "pipedriveCategory": null,
    "sourceProductIds": [
      694
    ]
  },
  {
    "id": "wt-690",
    "name": "Design Consultation / Workshop, Remote",
    "team": "Delivery Team",
    "pipedriveCategory": null,
    "sourceProductIds": [
      690
    ]
  },
  {
    "id": "wt-584",
    "name": "Design Meeting - 1 Hour",
    "team": "Delivery Team",
    "pipedriveCategory": "General",
    "sourceProductIds": [
      584
    ]
  },
  {
    "id": "wt-585",
    "name": "Design Meeting - 2 Hours",
    "team": "Delivery Team",
    "pipedriveCategory": "General",
    "sourceProductIds": [
      585
    ]
  },
  {
    "id": "wt-715",
    "name": "Design of Temporary Propping Systems",
    "team": "Delivery Team",
    "pipedriveCategory": null,
    "sourceProductIds": [
      715
    ]
  },
  {
    "id": "wt-640",
    "name": "Design of Temporary Structures",
    "team": "Delivery Team",
    "pipedriveCategory": "Events",
    "sourceProductIds": [
      640
    ]
  },
  {
    "id": "wt-547",
    "name": "Design Optimization",
    "team": "Delivery Team",
    "pipedriveCategory": null,
    "sourceProductIds": [
      547
    ]
  },
  {
    "id": "wt-546",
    "name": "Design Review",
    "team": "Delivery Team",
    "pipedriveCategory": null,
    "sourceProductIds": [
      546,
      708
    ]
  },
  {
    "id": "wt-533",
    "name": "Design Workshop",
    "team": "Delivery Team",
    "pipedriveCategory": "General",
    "sourceProductIds": [
      533
    ]
  },
  {
    "id": "wt-660",
    "name": "Detailed Design",
    "team": "Delivery Team",
    "pipedriveCategory": "Interiors - Large Projects",
    "sourceProductIds": [
      660
    ]
  },
  {
    "id": "wt-587",
    "name": "Detailed Design Package",
    "team": "Delivery Team",
    "pipedriveCategory": "Interiors - Large Projects",
    "sourceProductIds": [
      587
    ]
  },
  {
    "id": "wt-689",
    "name": "Detailed Seismic Restraint Design, per SQM",
    "team": "Delivery Team",
    "pipedriveCategory": "Interiors",
    "sourceProductIds": [
      689
    ]
  },
  {
    "id": "wt-751",
    "name": "Detailed Seismic Review",
    "team": "Delivery Team",
    "pipedriveCategory": null,
    "sourceProductIds": [
      751
    ]
  },
  {
    "id": "wt-586",
    "name": "Developed Design Package",
    "team": "Delivery Team",
    "pipedriveCategory": "Documentation",
    "sourceProductIds": [
      586
    ]
  },
  {
    "id": "wt-553",
    "name": "Document Retrieval",
    "team": "Delivery Team",
    "pipedriveCategory": "Admin",
    "sourceProductIds": [
      553
    ]
  },
  {
    "id": "wt-526",
    "name": "Engineer's Certification",
    "team": "Delivery Team",
    "pipedriveCategory": "Certification of Equipment & Machinery",
    "sourceProductIds": [
      526
    ]
  },
  {
    "id": "wt-548",
    "name": "Engineer's letter",
    "team": "Delivery Team",
    "pipedriveCategory": "Documentation",
    "sourceProductIds": [
      548,
      531
    ]
  },
  {
    "id": "wt-630",
    "name": "Engineering Support",
    "team": "Delivery Team",
    "pipedriveCategory": "Interiors - Large Projects",
    "sourceProductIds": [
      630,
      636,
      635
    ]
  },
  {
    "id": "wt-676",
    "name": "Executive Workshop",
    "team": "Delivery Team",
    "pipedriveCategory": "General",
    "sourceProductIds": [
      676
    ]
  },
  {
    "id": "wt-535",
    "name": "Finite Element Analysis (FEA)",
    "team": "Delivery Team",
    "pipedriveCategory": "General",
    "sourceProductIds": [
      535
    ]
  },
  {
    "id": "wt-644",
    "name": "For Construction Design Package",
    "team": "Delivery Team",
    "pipedriveCategory": "Interiors - Large Projects",
    "sourceProductIds": [
      644
    ]
  },
  {
    "id": "wt-728",
    "name": "GPC Asia Pacific - Option 1A - PS1 design of existing racking and/or shelving (up to 150 bays, 1 frame type, 3 config)",
    "team": "Delivery Team",
    "pipedriveCategory": null,
    "sourceProductIds": [
      728
    ]
  },
  {
    "id": "wt-729",
    "name": "GPC Asia Pacific - Option 1B - PS1 design of existing racking and/or shelving (up to 200 bays, 2 frame types, 5 config)",
    "team": "Delivery Team",
    "pipedriveCategory": null,
    "sourceProductIds": [
      729
    ]
  },
  {
    "id": "wt-730",
    "name": "GPC Asia Pacific - Option 1C - PS1 design of existing racking and/or shelving (up to 500 bays, 4 frame type, 6 config)",
    "team": "Delivery Team",
    "pipedriveCategory": null,
    "sourceProductIds": [
      730
    ]
  },
  {
    "id": "wt-731",
    "name": "GPC Asia Pacific - Option 2A - PS1 design of existing elevated walkways",
    "team": "Delivery Team",
    "pipedriveCategory": null,
    "sourceProductIds": [
      731
    ]
  },
  {
    "id": "wt-732",
    "name": "GPC Asia Pacific - Option 3A - Initial site visit, remote",
    "team": "Delivery Team",
    "pipedriveCategory": null,
    "sourceProductIds": [
      732
    ]
  },
  {
    "id": "wt-733",
    "name": "GPC Asia Pacific - Option 3B - Initial site visit, onsite metro (within Auckland/Christchurch)",
    "team": "Delivery Team",
    "pipedriveCategory": null,
    "sourceProductIds": [
      733
    ]
  },
  {
    "id": "wt-734",
    "name": "GPC Asia Pacific - Option 3C - Initial site visit, onsite regional (outside Auckland/Christchurch)",
    "team": "Delivery Team",
    "pipedriveCategory": null,
    "sourceProductIds": [
      734
    ]
  },
  {
    "id": "wt-735",
    "name": "GPC Asia Pacific - PS4 construction monitoring certificate",
    "team": "Delivery Team",
    "pipedriveCategory": null,
    "sourceProductIds": [
      735
    ]
  },
  {
    "id": "wt-760",
    "name": "Height Safety",
    "team": "Delivery Team",
    "pipedriveCategory": null,
    "sourceProductIds": [
      760
    ]
  },
  {
    "id": "wt-659",
    "name": "Initial Scoping Exercise / Proof of Concept to help bring the Competency Framework into a leading edge digital format.",
    "team": "Delivery Team",
    "pipedriveCategory": "Digital",
    "sourceProductIds": [
      659
    ]
  },
  {
    "id": "wt-750",
    "name": "Initial Seismic Review",
    "team": "Delivery Team",
    "pipedriveCategory": null,
    "sourceProductIds": [
      750
    ]
  },
  {
    "id": "wt-709",
    "name": "Initial site visit to inspect as-built elements, metro",
    "team": "Delivery Team",
    "pipedriveCategory": null,
    "sourceProductIds": [
      709
    ]
  },
  {
    "id": "wt-707",
    "name": "Material Quality Control and Engineering as required for Product Import and Specification",
    "team": "Delivery Team",
    "pipedriveCategory": null,
    "sourceProductIds": [
      707
    ]
  },
  {
    "id": "wt-783",
    "name": "Monkeytoe - 10 Year Recertification",
    "team": "Delivery Team",
    "pipedriveCategory": null,
    "sourceProductIds": [
      783
    ]
  },
  {
    "id": "wt-762",
    "name": "Monkeytoe - Additional Product Systems",
    "team": "Delivery Team",
    "pipedriveCategory": "Fall Arrest",
    "sourceProductIds": [
      762
    ]
  },
  {
    "id": "wt-767",
    "name": "Monkeytoe - Bespoke Elements",
    "team": "Delivery Team",
    "pipedriveCategory": "Fall Arrest",
    "sourceProductIds": [
      767,
      774
    ]
  },
  {
    "id": "wt-756",
    "name": "Monkeytoe - Bridge System",
    "team": "Delivery Team",
    "pipedriveCategory": "Fall Arrest",
    "sourceProductIds": [
      756
    ]
  },
  {
    "id": "wt-591",
    "name": "Monkeytoe - Height Safety System",
    "team": "Delivery Team",
    "pipedriveCategory": "Fall Arrest",
    "sourceProductIds": [
      591
    ]
  },
  {
    "id": "wt-784",
    "name": "Monkeytoe - Hourly Rate",
    "team": "Delivery Team",
    "pipedriveCategory": "Fall Arrest",
    "sourceProductIds": [
      784
    ]
  },
  {
    "id": "wt-770",
    "name": "Monkeytoe - NCC Australia - Compliance Certificate - NSW (NCC)",
    "team": "Delivery Team",
    "pipedriveCategory": "Fall Arrest",
    "sourceProductIds": [
      770
    ]
  },
  {
    "id": "wt-768",
    "name": "Monkeytoe - NCC Australia - Compliance Certificate - QLD (Form 15)",
    "team": "Delivery Team",
    "pipedriveCategory": "Fall Arrest",
    "sourceProductIds": [
      768
    ]
  },
  {
    "id": "wt-769",
    "name": "Monkeytoe - NCC Australia - Compliance Certificate - SA (NCC)",
    "team": "Delivery Team",
    "pipedriveCategory": "Fall Arrest",
    "sourceProductIds": [
      769
    ]
  },
  {
    "id": "wt-772",
    "name": "Monkeytoe - NCC Australia - Compliance Certificate - TAS (Form 35)",
    "team": "Delivery Team",
    "pipedriveCategory": "Fall Arrest",
    "sourceProductIds": [
      772
    ]
  },
  {
    "id": "wt-759",
    "name": "Monkeytoe - NCC Australia - Compliance Certificate - VIC (Reg 126)",
    "team": "Delivery Team",
    "pipedriveCategory": "Fall Arrest",
    "sourceProductIds": [
      759
    ]
  },
  {
    "id": "wt-771",
    "name": "Monkeytoe - NCC Australia - Compliance Certificate - WA (NCC)",
    "team": "Delivery Team",
    "pipedriveCategory": "Fall Arrest",
    "sourceProductIds": [
      771
    ]
  },
  {
    "id": "wt-657",
    "name": "Monkeytoe - NZBC PS4",
    "team": "Delivery Team",
    "pipedriveCategory": "Fall Arrest",
    "sourceProductIds": [
      657
    ]
  },
  {
    "id": "wt-778",
    "name": "Monkeytoe - NZBC PS4 - Additional Product Systems",
    "team": "Delivery Team",
    "pipedriveCategory": "Fall Arrest",
    "sourceProductIds": [
      778
    ]
  },
  {
    "id": "wt-761",
    "name": "Monkeytoe - Preliminary Design Check",
    "team": "Delivery Team",
    "pipedriveCategory": "Fall Arrest",
    "sourceProductIds": [
      761
    ]
  },
  {
    "id": "wt-763",
    "name": "Monkeytoe - Purlin-Mounted Platforms",
    "team": "Delivery Team",
    "pipedriveCategory": "Fall Arrest",
    "sourceProductIds": [
      763
    ]
  },
  {
    "id": "wt-765",
    "name": "Monkeytoe - Screening Systems",
    "team": "Delivery Team",
    "pipedriveCategory": "Fall Arrest",
    "sourceProductIds": [
      765
    ]
  },
  {
    "id": "wt-766",
    "name": "Monkeytoe - Stair Systems",
    "team": "Delivery Team",
    "pipedriveCategory": "Fall Arrest",
    "sourceProductIds": [
      766
    ]
  },
  {
    "id": "wt-764",
    "name": "Monkeytoe - XBEAM Structural Platforms",
    "team": "Delivery Team",
    "pipedriveCategory": "Fall Arrest",
    "sourceProductIds": [
      764
    ]
  },
  {
    "id": "wt-530",
    "name": "NCC Australia - Compliance Certificate - QLD (Form 16)",
    "team": "Delivery Team",
    "pipedriveCategory": "Documentation",
    "sourceProductIds": [
      530
    ]
  },
  {
    "id": "wt-678",
    "name": "NCC Australia - Compliance Certificate - SA",
    "team": "Delivery Team",
    "pipedriveCategory": "Documentation",
    "sourceProductIds": [
      678
    ]
  },
  {
    "id": "wt-739",
    "name": "NCC Australia - Compliance Certificate - TAS",
    "team": "Delivery Team",
    "pipedriveCategory": null,
    "sourceProductIds": [
      739
    ]
  },
  {
    "id": "wt-684",
    "name": "NCC Australia - Compliance Certificate - WA",
    "team": "Delivery Team",
    "pipedriveCategory": "Documentation",
    "sourceProductIds": [
      684
    ]
  },
  {
    "id": "wt-713",
    "name": "NCC Australia - Construction Monitoring Certificate",
    "team": "Delivery Team",
    "pipedriveCategory": null,
    "sourceProductIds": [
      713
    ]
  },
  {
    "id": "wt-623",
    "name": "NCC Australia - Generic Compliance Certificate - NSW - Various Locations",
    "team": "Delivery Team",
    "pipedriveCategory": "Documentation",
    "sourceProductIds": [
      623
    ]
  },
  {
    "id": "wt-625",
    "name": "NCC Australia - Generic Compliance Certificate - NT (Section 40) - Various Locations",
    "team": "Delivery Team",
    "pipedriveCategory": "Documentation",
    "sourceProductIds": [
      625
    ]
  },
  {
    "id": "wt-523",
    "name": "NCC Australia - Generic Compliance Certificate - QLD (Form 15) - Various Locations",
    "team": "Delivery Team",
    "pipedriveCategory": "Documentation",
    "sourceProductIds": [
      523
    ]
  },
  {
    "id": "wt-624",
    "name": "NCC Australia - Generic Compliance Certificate - TAS (Form 35) - Various Locations",
    "team": "Delivery Team",
    "pipedriveCategory": "Documentation",
    "sourceProductIds": [
      624
    ]
  },
  {
    "id": "wt-622",
    "name": "NCC Australia - Generic Compliance Certificate - VIC (Reg 126) - Various Locations",
    "team": "Delivery Team",
    "pipedriveCategory": "Documentation",
    "sourceProductIds": [
      622
    ]
  },
  {
    "id": "wt-653",
    "name": "NCC Australia - Site Specific Compliance Certificate - NSW",
    "team": "Delivery Team",
    "pipedriveCategory": "Documentation",
    "sourceProductIds": [
      653
    ]
  },
  {
    "id": "wt-627",
    "name": "NCC Australia - Site Specific Compliance Certificate - QLD (Form 15)",
    "team": "Delivery Team",
    "pipedriveCategory": "Documentation",
    "sourceProductIds": [
      627
    ]
  },
  {
    "id": "wt-610",
    "name": "NCC Australia - Site Specific Compliance Certificate - VIC (Reg 126)",
    "team": "Delivery Team",
    "pipedriveCategory": "Documentation",
    "sourceProductIds": [
      610
    ]
  },
  {
    "id": "wt-498",
    "name": "NZBC PS1 - Design Certificate",
    "team": "Delivery Team",
    "pipedriveCategory": "Documentation",
    "sourceProductIds": [
      498,
      668,
      597
    ]
  },
  {
    "id": "wt-542",
    "name": "NZBC PS1 - Design Certificate - Integrated Racking Structure (IRS)",
    "team": "Delivery Team",
    "pipedriveCategory": "Racking",
    "sourceProductIds": [
      542
    ]
  },
  {
    "id": "wt-693",
    "name": "NZBC PS1 - Design Certificate - Mezzanine Floor Structure",
    "team": "Delivery Team",
    "pipedriveCategory": null,
    "sourceProductIds": [
      693
    ]
  },
  {
    "id": "wt-691",
    "name": "NZBC PS1 - Design Certificate - Mezzanine Racking Structure",
    "team": "Delivery Team",
    "pipedriveCategory": null,
    "sourceProductIds": [
      691
    ]
  },
  {
    "id": "wt-575",
    "name": "NZBC PS1 - Design Certificate - Racking",
    "team": "Delivery Team",
    "pipedriveCategory": "Racking",
    "sourceProductIds": [
      575
    ]
  },
  {
    "id": "wt-710",
    "name": "NZBC PS1 - Design of Elevated Walkways",
    "team": "Delivery Team",
    "pipedriveCategory": null,
    "sourceProductIds": [
      710
    ]
  },
  {
    "id": "wt-620",
    "name": "NZBC PS1 - Generic Design Certificate - Various Locations (annual renewal required)",
    "team": "Delivery Team",
    "pipedriveCategory": "Documentation",
    "sourceProductIds": [
      620
    ]
  },
  {
    "id": "wt-619",
    "name": "NZBC PS1 - Generic Design Certificate Renewal",
    "team": "Delivery Team",
    "pipedriveCategory": "Documentation",
    "sourceProductIds": [
      619
    ]
  },
  {
    "id": "wt-527",
    "name": "NZBC PS1 - Revision",
    "team": "Delivery Team",
    "pipedriveCategory": "Documentation",
    "sourceProductIds": [
      527
    ]
  },
  {
    "id": "wt-521",
    "name": "NZBC PS2 - Design Review Certificate",
    "team": "Delivery Team",
    "pipedriveCategory": "Documentation",
    "sourceProductIds": [
      521
    ]
  },
  {
    "id": "wt-658",
    "name": "NZBC PS3 - Construction Certificate",
    "team": "Delivery Team",
    "pipedriveCategory": "Documentation",
    "sourceProductIds": [
      658
    ]
  },
  {
    "id": "wt-517",
    "name": "NZBC PS4 - Construction Monitoring Certificate",
    "team": "Delivery Team",
    "pipedriveCategory": "Documentation",
    "sourceProductIds": [
      517,
      669
    ]
  },
  {
    "id": "wt-633",
    "name": "NZBC PS4 - Construction Monitoring Certificate - Revision",
    "team": "Delivery Team",
    "pipedriveCategory": "Documentation",
    "sourceProductIds": [
      633
    ]
  },
  {
    "id": "wt-705",
    "name": "NZBC PS4 - Construction Monitoring Certificate (Metro inspection included)",
    "team": "Delivery Team",
    "pipedriveCategory": "Documentation",
    "sourceProductIds": [
      705
    ]
  },
  {
    "id": "wt-652",
    "name": "NZBC PS4 - Construction Monitoring Certificate (remote inspection included)",
    "team": "Delivery Team",
    "pipedriveCategory": "Documentation",
    "sourceProductIds": [
      652,
      740,
      755
    ]
  },
  {
    "id": "wt-506",
    "name": "Partition design",
    "team": "Delivery Team",
    "pipedriveCategory": "Interiors",
    "sourceProductIds": [
      506
    ]
  },
  {
    "id": "wt-639",
    "name": "Photo based assessment",
    "team": "Delivery Team",
    "pipedriveCategory": null,
    "sourceProductIds": [
      639
    ]
  },
  {
    "id": "wt-583",
    "name": "Pigeon Hole Racking - Engineering Investigation",
    "team": "Delivery Team",
    "pipedriveCategory": "Racking",
    "sourceProductIds": [
      583
    ]
  },
  {
    "id": "wt-551",
    "name": "Preliminary Design",
    "team": "Delivery Team",
    "pipedriveCategory": "Documentation",
    "sourceProductIds": [
      551
    ]
  },
  {
    "id": "wt-687",
    "name": "Preliminary Design - Integrated Racking Structure (IRS)",
    "team": "Delivery Team",
    "pipedriveCategory": "Racking",
    "sourceProductIds": [
      687
    ]
  },
  {
    "id": "wt-655",
    "name": "Preliminary PRENGUIN Design",
    "team": "Delivery Team",
    "pipedriveCategory": "Prenguin",
    "sourceProductIds": [
      655
    ]
  },
  {
    "id": "wt-688",
    "name": "Preliminary Seismic Restraint Design, per SQM",
    "team": "Delivery Team",
    "pipedriveCategory": "Interiors",
    "sourceProductIds": [
      688
    ]
  },
  {
    "id": "wt-519",
    "name": "Producer Statement revision",
    "team": "Delivery Team",
    "pipedriveCategory": "Revision",
    "sourceProductIds": [
      519
    ]
  },
  {
    "id": "wt-675",
    "name": "Product system design verification",
    "team": "Delivery Team",
    "pipedriveCategory": "Interiors - Large Projects",
    "sourceProductIds": [
      675
    ]
  },
  {
    "id": "wt-736",
    "name": "Protector Aluminium - Site-specific PS1",
    "team": "Delivery Team",
    "pipedriveCategory": null,
    "sourceProductIds": [
      736
    ]
  },
  {
    "id": "wt-704",
    "name": "Provisional Sum for any design changes",
    "team": "Delivery Team",
    "pipedriveCategory": null,
    "sourceProductIds": [
      704
    ]
  },
  {
    "id": "wt-529",
    "name": "Racking",
    "team": "Delivery Team",
    "pipedriveCategory": "Racking",
    "sourceProductIds": [
      529,
      580,
      581
    ]
  },
  {
    "id": "wt-637",
    "name": "Racking Annual Audit Report, AS4084:2023",
    "team": "Delivery Team",
    "pipedriveCategory": "Racking",
    "sourceProductIds": [
      637
    ]
  },
  {
    "id": "wt-632",
    "name": "Racking Assessment for Safe Working Loads",
    "team": "Delivery Team",
    "pipedriveCategory": "Racking",
    "sourceProductIds": [
      632
    ]
  },
  {
    "id": "wt-629",
    "name": "Racking Plinth Design",
    "team": "Delivery Team",
    "pipedriveCategory": "Racking",
    "sourceProductIds": [
      629
    ]
  },
  {
    "id": "wt-631",
    "name": "Racking Slab Assessment and Design",
    "team": "Delivery Team",
    "pipedriveCategory": "Racking",
    "sourceProductIds": [
      631
    ]
  },
  {
    "id": "wt-607",
    "name": "Racking Slab Check – Desktop Assessment (Client to Provide Slab Info: Thickness, MPa, Drawings)",
    "team": "Delivery Team",
    "pipedriveCategory": "Racking",
    "sourceProductIds": [
      607,
      779
    ]
  },
  {
    "id": "wt-540",
    "name": "Re-Analysis Calculations (Iterations)",
    "team": "Delivery Team",
    "pipedriveCategory": "Design Compliance",
    "sourceProductIds": [
      540
    ]
  },
  {
    "id": "wt-538",
    "name": "Re-Certification",
    "team": "Delivery Team",
    "pipedriveCategory": "Certification of Equipment & Machinery",
    "sourceProductIds": [
      538
    ]
  },
  {
    "id": "wt-598",
    "name": "Report",
    "team": "Delivery Team",
    "pipedriveCategory": "Design Compliance",
    "sourceProductIds": [
      598
    ]
  },
  {
    "id": "wt-696",
    "name": "Review current compliance requirements",
    "team": "Delivery Team",
    "pipedriveCategory": null,
    "sourceProductIds": [
      696
    ]
  },
  {
    "id": "wt-699",
    "name": "Review of updated drawings",
    "team": "Delivery Team",
    "pipedriveCategory": null,
    "sourceProductIds": [
      699
    ]
  },
  {
    "id": "wt-518",
    "name": "Revision of building element designs",
    "team": "Delivery Team",
    "pipedriveCategory": "Admin",
    "sourceProductIds": [
      518
    ]
  },
  {
    "id": "wt-612",
    "name": "Risk Assessment of As-Built Glazed Partitions",
    "team": "Delivery Team",
    "pipedriveCategory": "Interiors",
    "sourceProductIds": [
      612
    ]
  },
  {
    "id": "wt-578",
    "name": "Scan of As-Built Services",
    "team": "Delivery Team",
    "pipedriveCategory": "Interiors",
    "sourceProductIds": [
      578
    ]
  },
  {
    "id": "wt-670",
    "name": "Seismic Design and Specification Drawings",
    "team": "Delivery Team",
    "pipedriveCategory": "Documentation",
    "sourceProductIds": [
      670
    ]
  },
  {
    "id": "wt-673",
    "name": "Seismic Guidelines Report",
    "team": "Delivery Team",
    "pipedriveCategory": "Documentation",
    "sourceProductIds": [
      673
    ]
  },
  {
    "id": "wt-638",
    "name": "Seismic Restraint Design",
    "team": "Delivery Team",
    "pipedriveCategory": "Interiors",
    "sourceProductIds": [
      638
    ]
  },
  {
    "id": "wt-576",
    "name": "Seismic restraint design for Audio Visual Services, per item",
    "team": "Delivery Team",
    "pipedriveCategory": "Interiors",
    "sourceProductIds": [
      576
    ]
  },
  {
    "id": "wt-522",
    "name": "Seismic restraint design for Balustrades, Screens, Pergolas or Louvres",
    "team": "Delivery Team",
    "pipedriveCategory": "Interiors",
    "sourceProductIds": [
      522
    ]
  },
  {
    "id": "wt-502",
    "name": "Seismic restraint design for bespoke suspended ceilings",
    "team": "Delivery Team",
    "pipedriveCategory": "Interiors",
    "sourceProductIds": [
      502
    ]
  },
  {
    "id": "wt-505",
    "name": "Seismic restraint design for bulkheads",
    "team": "Delivery Team",
    "pipedriveCategory": "Interiors",
    "sourceProductIds": [
      505
    ]
  },
  {
    "id": "wt-590",
    "name": "Seismic restraint design for electrical services, medium density per SQM",
    "team": "Delivery Team",
    "pipedriveCategory": "Interiors (Education/Residential density)",
    "sourceProductIds": [
      590
    ]
  },
  {
    "id": "wt-559",
    "name": "Seismic restraint design for electrical services, per SQM",
    "team": "Delivery Team",
    "pipedriveCategory": "Interiors",
    "sourceProductIds": [
      559
    ]
  },
  {
    "id": "wt-782",
    "name": "Seismic restraint design for EP services (electrical and hydraulic), per SQM",
    "team": "Delivery Team",
    "pipedriveCategory": null,
    "sourceProductIds": [
      782
    ]
  },
  {
    "id": "wt-617",
    "name": "Seismic restraint design for exterior partitions, per linear m",
    "team": "Delivery Team",
    "pipedriveCategory": "Interiors",
    "sourceProductIds": [
      617,
      773
    ]
  },
  {
    "id": "wt-641",
    "name": "Seismic restraint design for fixed ceilings, per SQM",
    "team": "Delivery Team",
    "pipedriveCategory": "Interiors",
    "sourceProductIds": [
      641
    ]
  },
  {
    "id": "wt-511",
    "name": "Seismic restraint design for floor mounted services",
    "team": "Delivery Team",
    "pipedriveCategory": "Interiors",
    "sourceProductIds": [
      511
    ]
  },
  {
    "id": "wt-695",
    "name": "Seismic restraint design for glazed curtain wall",
    "team": "Delivery Team",
    "pipedriveCategory": null,
    "sourceProductIds": [
      695
    ]
  },
  {
    "id": "wt-573",
    "name": "Seismic restraint design for hydraulic services, medium density per SQM",
    "team": "Delivery Team",
    "pipedriveCategory": "Interiors (Education/Residential density)",
    "sourceProductIds": [
      573
    ]
  },
  {
    "id": "wt-560",
    "name": "Seismic restraint design for hydraulic services, per SQM",
    "team": "Delivery Team",
    "pipedriveCategory": "Interiors",
    "sourceProductIds": [
      560
    ]
  },
  {
    "id": "wt-562",
    "name": "Seismic restraint design for hydraulic, mechanical and electrical services, Education, per SQM",
    "team": "Delivery Team",
    "pipedriveCategory": "Interiors (Education/Residential density)",
    "sourceProductIds": [
      562
    ]
  },
  {
    "id": "wt-614",
    "name": "Seismic restraint design for hydraulic, mechanical, fire and electrical services, Education, per SQM",
    "team": "Delivery Team",
    "pipedriveCategory": "Interiors (Education/Residential density)",
    "sourceProductIds": [
      614
    ]
  },
  {
    "id": "wt-692",
    "name": "Seismic restraint design for interior bespoke elements",
    "team": "Delivery Team",
    "pipedriveCategory": null,
    "sourceProductIds": [
      692
    ]
  },
  {
    "id": "wt-645",
    "name": "Seismic restraint design for interior load-bearing partitions, per linear m",
    "team": "Delivery Team",
    "pipedriveCategory": "Interiors",
    "sourceProductIds": [
      645
    ]
  },
  {
    "id": "wt-569",
    "name": "Seismic restraint design for interior non-load bearing partitions, per linear m",
    "team": "Delivery Team",
    "pipedriveCategory": "Interiors",
    "sourceProductIds": [
      569
    ]
  },
  {
    "id": "wt-557",
    "name": "Seismic restraint design for interior non-load bearing partitions, per linear m (scope excludes load-bearing partitions, operable walls and lintel openings larger than 3.5m)",
    "team": "Delivery Team",
    "pipedriveCategory": "Interiors",
    "sourceProductIds": [
      557
    ]
  },
  {
    "id": "wt-680",
    "name": "Seismic restraint design for interior non-load bearing partitions, per SQM",
    "team": "Delivery Team",
    "pipedriveCategory": "Interiors",
    "sourceProductIds": [
      680
    ]
  },
  {
    "id": "wt-571",
    "name": "Seismic restraint design for mechanical services, medium density per SQM",
    "team": "Delivery Team",
    "pipedriveCategory": "Interiors (Education/Residential density)",
    "sourceProductIds": [
      571
    ]
  },
  {
    "id": "wt-555",
    "name": "Seismic restraint design for mechanical services, per SQM",
    "team": "Delivery Team",
    "pipedriveCategory": "Interiors",
    "sourceProductIds": [
      555
    ]
  },
  {
    "id": "wt-574",
    "name": "Seismic restraint design for mechanical services, plant room, per SQM",
    "team": "Delivery Team",
    "pipedriveCategory": "Interiors",
    "sourceProductIds": [
      574
    ]
  },
  {
    "id": "wt-570",
    "name": "Seismic restraint design for MEP services (mechanical, electrical and hydraulic), per SQM",
    "team": "Delivery Team",
    "pipedriveCategory": "Interiors",
    "sourceProductIds": [
      570
    ]
  },
  {
    "id": "wt-564",
    "name": "Seismic restraint design for MEPF services (Mechanical, Electrical, Plumbing and Fire pipework), per SQM",
    "team": "Delivery Team",
    "pipedriveCategory": "Interiors",
    "sourceProductIds": [
      564
    ]
  },
  {
    "id": "wt-781",
    "name": "Seismic Restraint Design for Mounted Components",
    "team": "Delivery Team",
    "pipedriveCategory": null,
    "sourceProductIds": [
      781
    ]
  },
  {
    "id": "wt-634",
    "name": "Seismic restraint design for roof mounted services",
    "team": "Delivery Team",
    "pipedriveCategory": "Interiors",
    "sourceProductIds": [
      634
    ]
  },
  {
    "id": "wt-753",
    "name": "Seismic restraint design for roof plant, per SQM",
    "team": "Delivery Team",
    "pipedriveCategory": null,
    "sourceProductIds": [
      753
    ]
  },
  {
    "id": "wt-504",
    "name": "Seismic restraint design for soffit ceilings",
    "team": "Delivery Team",
    "pipedriveCategory": "Interiors",
    "sourceProductIds": [
      504
    ]
  },
  {
    "id": "wt-497",
    "name": "Seismic restraint design for suspended ceilings",
    "team": "Delivery Team",
    "pipedriveCategory": "Interiors",
    "sourceProductIds": [
      497
    ]
  },
  {
    "id": "wt-563",
    "name": "Seismic restraint design for suspended ceilings, Education, per SQM",
    "team": "Delivery Team",
    "pipedriveCategory": "Interiors (Education/Residential density)",
    "sourceProductIds": [
      563
    ]
  },
  {
    "id": "wt-556",
    "name": "Seismic restraint design for suspended ceilings, per SQM",
    "team": "Delivery Team",
    "pipedriveCategory": "Interiors",
    "sourceProductIds": [
      556
    ]
  },
  {
    "id": "wt-558",
    "name": "Seismic restraint design for suspended ceilings, Residential, per SQM",
    "team": "Delivery Team",
    "pipedriveCategory": "Interiors (Education/Residential density)",
    "sourceProductIds": [
      558
    ]
  },
  {
    "id": "wt-561",
    "name": "Seismic restraint design for suspended fire pipework, per SQM",
    "team": "Delivery Team",
    "pipedriveCategory": "Interiors",
    "sourceProductIds": [
      561
    ]
  },
  {
    "id": "wt-572",
    "name": "Seismic restraint design for suspended fire services, medium density per SQM",
    "team": "Delivery Team",
    "pipedriveCategory": "Interiors (Education/Residential density)",
    "sourceProductIds": [
      572
    ]
  },
  {
    "id": "wt-600",
    "name": "Seismic restraint design for suspended soffits, per SQM",
    "team": "Delivery Team",
    "pipedriveCategory": "Interiors",
    "sourceProductIds": [
      600
    ]
  },
  {
    "id": "wt-613",
    "name": "Seismic restraint design for suspended soffits, Residential, per SQM",
    "team": "Delivery Team",
    "pipedriveCategory": "Interiors (Education/Residential density)",
    "sourceProductIds": [
      613
    ]
  },
  {
    "id": "wt-554",
    "name": "Seismic Restraint Design for Wall Mounted Components",
    "team": "Delivery Team",
    "pipedriveCategory": "Interiors",
    "sourceProductIds": [
      554
    ]
  },
  {
    "id": "wt-682",
    "name": "Seismic Restraint Design of Floor Mounted Components",
    "team": "Delivery Team",
    "pipedriveCategory": "Interiors",
    "sourceProductIds": [
      682
    ]
  },
  {
    "id": "wt-698",
    "name": "Seismic Restraint Design of Interior Elements, per SQM",
    "team": "Delivery Team",
    "pipedriveCategory": null,
    "sourceProductIds": [
      698
    ]
  },
  {
    "id": "wt-665",
    "name": "Seismic Restraint Takeoffs",
    "team": "Delivery Team",
    "pipedriveCategory": "Interiors",
    "sourceProductIds": [
      665
    ]
  },
  {
    "id": "wt-742",
    "name": "Shop Drawings",
    "team": "Delivery Team",
    "pipedriveCategory": null,
    "sourceProductIds": [
      742
    ]
  },
  {
    "id": "wt-596",
    "name": "Slab Check",
    "team": "Delivery Team",
    "pipedriveCategory": "Racking",
    "sourceProductIds": [
      596
    ]
  },
  {
    "id": "wt-663",
    "name": "Software Development",
    "team": "Delivery Team",
    "pipedriveCategory": "Digital",
    "sourceProductIds": [
      663
    ]
  },
  {
    "id": "wt-667",
    "name": "Software platform maintenance",
    "team": "Delivery Team",
    "pipedriveCategory": "Digital",
    "sourceProductIds": [
      667
    ]
  },
  {
    "id": "wt-525",
    "name": "Standard bulkhead design",
    "team": "Delivery Team",
    "pipedriveCategory": "Interiors",
    "sourceProductIds": [
      525
    ]
  },
  {
    "id": "wt-582",
    "name": "Standard Engineered Fall Arrest System",
    "team": "Delivery Team",
    "pipedriveCategory": null,
    "sourceProductIds": [
      582
    ]
  },
  {
    "id": "wt-524",
    "name": "Standard suspended ceiling design",
    "team": "Delivery Team",
    "pipedriveCategory": null,
    "sourceProductIds": [
      524
    ]
  },
  {
    "id": "wt-714",
    "name": "Statement of Construction Compliance (SoCC)",
    "team": "Delivery Team",
    "pipedriveCategory": null,
    "sourceProductIds": [
      714
    ]
  },
  {
    "id": "wt-661",
    "name": "Statement of Design Compliance - Existing Racking",
    "team": "Delivery Team",
    "pipedriveCategory": "Racking",
    "sourceProductIds": [
      661
    ]
  },
  {
    "id": "wt-677",
    "name": "Statement of Design Compliance - Racking",
    "team": "Delivery Team",
    "pipedriveCategory": "Racking",
    "sourceProductIds": [
      677
    ]
  },
  {
    "id": "wt-539",
    "name": "Statement of Design Compliance (SoDC)",
    "team": "Delivery Team",
    "pipedriveCategory": "Documentation",
    "sourceProductIds": [
      539
    ]
  },
  {
    "id": "wt-656",
    "name": "Statement of Install Compliance - Fall Arrest System",
    "team": "Delivery Team",
    "pipedriveCategory": "Fall Arrest",
    "sourceProductIds": [
      656
    ]
  },
  {
    "id": "wt-741",
    "name": "Statement of Install Compliance (SoIC)",
    "team": "Delivery Team",
    "pipedriveCategory": null,
    "sourceProductIds": [
      741
    ]
  },
  {
    "id": "wt-671",
    "name": "Structural Design & Installation Certificate (SDIC)",
    "team": "Delivery Team",
    "pipedriveCategory": "Documentation",
    "sourceProductIds": [
      671
    ]
  },
  {
    "id": "wt-775",
    "name": "Summertime Pools - NCC Australia - Site Specific Reg-126 Certificate",
    "team": "Delivery Team",
    "pipedriveCategory": null,
    "sourceProductIds": [
      775
    ]
  },
  {
    "id": "wt-510",
    "name": "Suspended Services",
    "team": "Delivery Team",
    "pipedriveCategory": "Interiors",
    "sourceProductIds": [
      510
    ]
  },
  {
    "id": "wt-536",
    "name": "Technical Report",
    "team": "Delivery Team",
    "pipedriveCategory": "Documentation",
    "sourceProductIds": [
      536
    ]
  },
  {
    "id": "wt-579",
    "name": "Tender Management Services",
    "team": "Delivery Team",
    "pipedriveCategory": "General",
    "sourceProductIds": [
      579
    ]
  },
  {
    "id": "wt-758",
    "name": "Tent Products",
    "team": "Delivery Team",
    "pipedriveCategory": null,
    "sourceProductIds": [
      758
    ]
  },
  {
    "id": "wt-700",
    "name": "Testing in accordance with AS/NZS1170.0 Appendix B",
    "team": "Delivery Team",
    "pipedriveCategory": null,
    "sourceProductIds": [
      700
    ]
  },
  {
    "id": "wt-681",
    "name": "Total Height Safety - NZBC PS1 Design Certificate - Fall Arrest System",
    "team": "Delivery Team",
    "pipedriveCategory": "Fall Arrest",
    "sourceProductIds": [
      681
    ]
  },
  {
    "id": "wt-686",
    "name": "Total Height Safety - NZBC PS4 Design Certificate - Fall Arrest System",
    "team": "Delivery Team",
    "pipedriveCategory": "Fall Arrest",
    "sourceProductIds": [
      686
    ]
  },
  {
    "id": "wt-666",
    "name": "Value Engineering of Seismic Restraint Design",
    "team": "Delivery Team",
    "pipedriveCategory": "Interiors",
    "sourceProductIds": [
      666
    ]
  },
  {
    "id": "wt-541",
    "name": "Wind Zone",
    "team": "Delivery Team",
    "pipedriveCategory": "Other",
    "sourceProductIds": [
      541
    ]
  },
  {
    "id": "wt-534",
    "name": "Workshop",
    "team": "Delivery Team",
    "pipedriveCategory": "General",
    "sourceProductIds": [
      534
    ]
  }
]
